import { usageId } from '../../../../../constants/usageid.js';
import { DataTableConfigurationSchemaIds, DataTableConfigurationTags } from '../../schemas/configuration.const.js';
export const dictionary = {
    schema: {
        [usageId(DataTableConfigurationSchemaIds.DATA_TABLE_CONFIGURATION, DataTableConfigurationTags.DEFAULT)]: {
            title: 'Data Table Configuration',
            description: 'Options that apply to the Data Table.',
            abbr: 'Data Table config.',
            cti: 'Set the Data Table options.'
        }
    }
};
